<template>
  <div id="app" v-loading.fullscreen.lock="fullscreenLoading">
    <router-view v-if="isRouterAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import Home from './components/layout/Home.vue'
import { socketInit } from "@/utils/socket"
export default {
  data() {
    return {
      isRouterAlive: true,
      fullscreenLoading: this.$store.state.fullscreenLoading,
    }

  },
  created() {
    this.initGlobalSocket()
  },
  methods: {
    initGlobalSocket() {
      if (localStorage.getItem("token")) {
        socketInit()
      }
    }
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  name: 'app',
  components: {
    Home
  },
  reload() {
    this.isRouterAlive = false
    this.$nextTick(() => {
      this.isRouterAlive = true
    })

  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}

@keyframes blink-red {
  0% {
    box-shadow: 0 0 5px #F56C6C;
  }

  50% {
    box-shadow: 0 0 20px #F56C6C;
  }

  100% {
    box-shadow: 0 0 5px #F56C6C;
  }
}

.el-message--warning {
  border: 2px solid #F56C6C !important;
  animation: blink-red 1s infinite;
}
.green-loading .el-loading-text {
  color: #0caf60 !important;
}

.green-loading .el-loading-spinner .path {
  stroke: #0caf60 !important;
}

.green-loading .el-loading-spinner i {
  color: #0caf60 !important;
}
</style>
